import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { EOtpremniceClient, TipIzmenePosiljke } from '@kodit/core/data-api';
import { FormHelper } from '@kodit/core/form-definitions';
import { AlertService, ButtonService, MixpanelService, SharedService } from '@kodit/core/services';
import { DynamicDialogConfig, DynamicDialogRef } from '@kodit/core/shared-ui';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'kodit-storno-eotpremnica-form',
  templateUrl: './storno-eotpremnica-form.component.html',
  styleUrls: ['./storno-eotpremnica-form.component.scss']
})
export class StornoEotpremnicaFormComponent implements OnInit, OnDestroy {

  private _subs: Subscription = new Subscription();
  form: FormGroup;

  constructor(
    private _fb: FormBuilder,
    private _client: EOtpremniceClient,
    private _alertService: AlertService,
    private _dialogRef: DynamicDialogRef,
    private _dialogConfig: DynamicDialogConfig,
    private _formHelper: FormHelper,
    //private _uploadService: FileUploadService,
    private _buttonService: ButtonService,
    //private _kontaktiClient: KontaktiClient,
    private _mixpanelService : MixpanelService,
    private _sharedService : SharedService
  ) { }

  ngOnInit(): void {

    this._subs.add(
      this._dialogRef.onSubmit.subscribe(() => {
        this._stornirajOtpremnicu();
      })
    );

    this.form = this._fb.group({
      otpremnicaId: new FormControl(this._dialogConfig.data.otpremnicaId, {
        validators: Validators.required,
      }),
      razlog: new FormControl('', {
        validators: Validators.required,
      })
    });

  }

  private _stornirajOtpremnicu() {
    if (!this.form.valid) {
      this._formHelper.invalidateForm(this.form);
      return;
    }

    this._buttonService.disableButton();

    // everything is ok, let's send it
    this._sharedService.displayLoadingScreen(true, "Storniranje otpremnice u toku");
    this._subs.add(
      this._client
        .akcijaOtpremnice(
          this._dialogConfig.data.otpremnicaId,
          TipIzmenePosiljke.STORNO,
          null,
          this.form.value.razlog
        )
        .pipe(
          finalize(() => {
            this._sharedService.resetLoadingScreen();
          })
        )
        .subscribe((res) => {
          if(res.succeeded){
            this._mixpanelService.izlaznaFakturaSentToSefSucceeded();
            this._alertService.addSuccessMsg(res.data);
            this._dialogRef.close(true);
            return;
          }
          this._alertService.addFailedMsg(res.messages[0]);
          this._dialogRef.close(true);
        })
    );
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }

}
